/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum ServicesBackendEnum {
    GENERAL = 0,
    HEADERS = 1,
    PERSISTENCE = 2,
    HEALTHCHECK = 3,
    CONNECTION = 4,
    ADVANCED = 5
}
